import React, { Component } from 'react';

import { getTemplateReport } from '../../data/serviceCrm';

import { InputRow } from '../../helpers/uiComponents/InputRow';

class CrmReport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			results: [],
			alert: [],
		}
	}

	getReport(templateId) {
		this.setState({alert: "fetching statistics for tempateId "+templateId});

		getTemplateReport(templateId).then(response => {
			var data = this.csvToArray(response);
			console.log(data);
			this.setState({
				alert: [],
				results: data,
			});
		})
	}

	csvToArray(csv){
		var lines = csv.split("\n");
		var headers = lines[0].split(",");
		var data = lines[1].split(",");
		var arr = {};

		for (var i = 0; i < headers.length; i++) {
			arr[headers[i]] = data[i];
		}

	  return arr;
	}



	render() {
		const { results, alert } = this.state;
		
		const sgTemplates = this.props.sgTemplates;
		
		return (
			<div>
				<section className="section campaign-test input-group">
					<h3>Email Campaign Report</h3>

					<InputRow label="SendGrid Email Template" type="select" property="template" options={sgTemplates} onChange={(e) => this.getReport(e.target.value)} />
					{/*<InputRow label="SendGrid Email Template ID" type="text" property="template" onChange={(e) => this.getReport(e.target.value)} />*/}
					<div>{alert}</div>
					<h5>Stats:</h5>
					<div>Sent: {results.sent}</div>
					<div>Delivered: {results.delivered}</div>
					<div>Opened: {results.opened}</div>
					<div>Clicked: {results.clicked}</div>
					<div>Deferred: {results.deferred}</div>
					<div>Dropped: {results.dropped}</div>
					<div>Bounced: {results.bounced}</div>
					<div>Unsubscribed: {results.unsubscribe}</div>
				</section>
			</div>
		);
	}
}
export default CrmReport;


// WEBPACK FOOTER //
// ./src/component_crmTest/components/CrmReport.js